import React from "react";

const Btech = () => {
  return (
    <div className="album py-2">
      {/* Add lines from 7 to 40 in the top for adding in the list. */}
      
      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/adhvet-sharma-0920a1255/"
        >
          <b> Adhvet Atul Sharma </b>
        </a>
        (2022-2026),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/amanaryan0112358/"
        >
          <b> Aman Aryan </b>
        </a>
        (2022-2026),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/mohit-singh-bb5430253/"
        >
          <b> Mohit Singh </b>
        </a>
        (2022-2026),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/hanzal-siddiqui-17a25b24a/"
        >
          <b> Shanzal Siddiqui </b>
        </a>
        (2022-2026),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/shreya-anumod-22877525a/"
        >
          <b> Shreya Anumod </b>
        </a>
        (2022-2026)
      </li>


    <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/abhishek-kumar-944b0b284/"
        >
          <b> Abhishek Kumar </b>
        </a>
        (2021-2025),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/ayush-kumar-1579a922b/"
        >
          <b> Ayush Kumar </b>
        </a>
        (2021-2025),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/nandan-kumar-singh-071574252/"
        >
          <b> Nandan Kumar Singh </b>
        </a>
        (2021-2025),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/prasenjit-chanda-5696a7227/"
        >
          <b> Prasenjit Chanda </b>
        </a>
        (2021-2025),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/suryansh-bansal-09507b241/"
        >
          <b> Suryansh Bansal </b>
        </a>
        (2021-2025)
      </li>


      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/abhay-chahar-163469279/"
        >
          <b> Abhay Chahar </b>
        </a>
        (2020-2024),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/navneet-kumar-chouhan-956943219/"
        >
          <b> Navneet Kr. Chouhan </b>
        </a>
        (2020-2024),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/rakesh-yadav-44435521a/"
        >
          <b> Rakesh Kumar Yadav </b>
        </a>
        (2020-2024),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/shoaib-rahman-768081247/"
        >
          <b> Shoaib Rahman </b>
        </a>
        (2020-2024),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/ujjwal-anand-753348218/"
        >
          <b> Ujjwal Anand </b>
        </a>
        (2020-2024)
      </li>

      
      
      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/ashish1gautam/"
        >
          <b> Ashish Kumar Gautam </b>
        </a>
        (2019-2023),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href=""
        >
          <b> Ishu Raj </b>
        </a>
        (2019-2023),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href=""
        >
          <b> Prazzwal Meena </b>
        </a>
        (2019-2023),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/ritik-kumar-gautam-5740711b2/"
        >
          <b> Ritik Kumar Gautam </b>
        </a>
        (2019-2023)
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/rohit-kumar-8600571ba/"
        >
          <b> Rohit Kumar </b>
        </a>
        (2019-2023),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/siddhant-soymon-806825217/"
        >
          <b> Siddhant Soymon </b>
        </a>
        (2019-2023)
      </li>
      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/ayushi-jain-938b27190/"
        >
          <b> Ayushi Jain </b>
        </a>
        (2018-2022),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/srija-karmakar-154676170/"
        >
          <b> Srija Karmakar </b>
        </a>
        (2018-2022),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/himansh-guddeti-53b5a0171/"
        >
          <b> Himansh Guddeti </b>
        </a>
        (2018-2022),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/shubham-kumar-305673183/"
        >
          <b> Shubham Kumar </b>
        </a>
        (2018-2022)
      </li>
      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/aashay-harshit-6ba3a8160/"
        >
          <b> Aashay Harshit </b>
        </a>
        (2017-2021),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/gaurav2299/"
        >
          
          <b> Gaurav Mishra </b>
        </a>
        (2017-2021),
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/riya-ranjan-911223159/"
        >
          
          <b> Riya Ranjan </b>
        </a>
        (2017-2021)
      </li>
    </div>
  );
};

export default Btech;
